/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Error_Message_MinInputs */

const en_contact_error_message_min = /** @type {(inputs: Contact_Error_Message_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sentence about the task is enough`)
};

const lv_contact_error_message_min = /** @type {(inputs: Contact_Error_Message_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pietiek ar vienu teikumu par darbu`)
};

/**
* | output |
* | --- |
* | "A sentence about the task is enough" |
*
* @param {Contact_Error_Message_MinInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_error_message_min = /** @type {((inputs?: Contact_Error_Message_MinInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Error_Message_MinInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_error_message_min(inputs)
	return en_contact_error_message_min(inputs)
});